import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import "./_style.scss";

const PageHero = ({
  cta,
  heading,
  look,
  minHeight,
  subheading,
  textAlign,
  ...other
}) => (
  <div
    className={
        classNames({
          "page-hero": true,
          [`--${look}`]: look,
          [`--${minHeight}`]: minHeight,
          [`--${textAlign}`]: textAlign,
        })
      }
    {...other}
  >
    <div className="page-hero__inner">
      <div className="page-hero__heading">
        {heading}
      </div>
      {subheading
          && (
          <div className="page-hero__subheading">
            {subheading}
          </div>
          )}
      {cta
          && (
          <div className="page-hero__cta">
            {cta}
          </div>
          )}
    </div>
  </div>
);

PageHero.propTypes = {
  cta: PropTypes.node,
  heading: PropTypes.node.isRequired,
  look: PropTypes.oneOf(["gradient", "plain"]),
  minHeight: PropTypes.oneOf(["100vh", "60vh", "short", "normal"]),
  subheading: PropTypes.node,
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
};

export default PageHero;
